export const CONFIG_SET_LOADING = 'CONFIG_SET_LOADING';

const setConfigLoading = (isLoading) => ({
    type: CONFIG_SET_LOADING,
    payload: isLoading,
  });

export const fetchConfig = () => {
    return async (dispatch, getState/* , apiClient: any */) => {
      dispatch(setConfigLoading(true));
      try {
        if (true) {
          /* const apIUrl = `REACT_APP_API_${process.env.REACT_APP_STAGE}`;
          //console.log(process.env[apIUrl]);
          apiClient.buildServices({ apiUrl: process.env[apIUrl]! }); */
        }
      } catch (error) {
      } finally {
        dispatch(setConfigLoading(false));
      }
    };
  };